import React, { Component, createRef } from 'react';
import ReactTooltip from 'react-tooltip';
import { connect } from 'react-redux';
import moment from 'moment';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

import { errorHandler, getContent, getErrorMessage } from '../../../util/responseUtil';
import API_REPORT from '../../../api/apiReport';
import DateRange from '../../../components/DateRange/DateRange';
import IconReportSuccess from '../../../assets/icons/IconReportSuccess';
import IconReportWarning from '../../../assets/icons/IconReportWarning';
import IconReportSendEmail from '../../../assets/icons/IconReportSendEmail';
import IconReportDownload from '../../../assets/icons/IconReportDownload';
import ActionType from '../../../redux/reducer/globalActionType';
import Alert from '../../../components/Alert/Alert';
import { CheckPermissionComponent } from '../../../util/permission';
import {
    PRINCIPAL_TICKET_REPORT_EXPORT_FILE_VIEW,
    PRINCIPAL_TICKET_REPORT_SEND_FILE_VIEW,
    PRINCIPAL_TICKET_REPORT_VIEW,
    PRINCIPAL_TICKET_REPORT_VIEW_OWN
} from '../../../constants/menuPermissionConstant';
import { ROLE_CATEGORY_CONSTANT } from '../../../constants/roleCategoryConstant';
import MENU_REPORT from '../../../constants/menuReportConstant';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
class PrincipalTicket extends Component {
    constructor(props) {
        super(props);
        this.state = {
            report: {
                page: 1,
                limit: 10,
                data: [],
                value: 0,
                total: 0
            },
            principal: {
                page: 1,
                limit: 100,
                data: [],
                value: [],
                id: ''
            },
            status: {
                page: 1,
                limit: 10,
                data: [],
                value: [{ 'status_ticket': 'all' }]
            },
            priority: {
                page: 1,
                limit: 10,
                data: [],
                value: []
            },
            distributor: {
                page: 1,
                limit: 100,
                data: [],
                value: [],
                id: '',
            },
            distributorCodeArray: {
                page: 1,
                limit: 100,
                data: [],
                value: [],
                id: ''
            },
            distributorCode: false,
            showDateRange: false,
            isSubmitted: false,
            periodStart: '',
            periodEnd: '',
            showLoadMore: true,
            titleConfirmAlertDownload: '',
            titleConfirmAlertEmail: '',
            showConfirmAlertDownload: false,
            showConfirmAlertEmail: false,
            showSuccessAlert: false,
            showErrorAlert: false,
            showErrorAlertResponse: false,
            errorMessage: '',
            showLoadingPrincipal: false,
            showLoadingDistributor: false,
            showLoadingDistributorCodeArray: false,
        }
    }

    getListPrincipal = id => {
        this.setState({ showLoadingPrincipal: true });
        API_REPORT.getListPrincipalReportPrincipal(this.state.principal.page, this.state.principal.limit, id, this.props.token)
            .then(res => {
                let principalList = getContent(res).map(principal => ({
                    value: principal.user_nexcare_id,
                    label: principal.customer_name,
                    id: principal.id
                }))
                if (this._isMounted) {
                    this.setState({
                        principal: {
                            ...this.state.principal,
                            data: principalList
                        },
                        showLoadingPrincipal: false,
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getSearchPrincipal = keyword => {
        this.setState({ showLoadingPrincipal: true });
        API_REPORT.getSearchPrincipalReportPrincipal(this.state.principal.page, this.state.principal.limit, keyword, this.state.distributor.id, this.props.token)
            .then(res => {
                let principalList = getContent(res).map(principal => ({
                    value: principal.user_nexcare_id,
                    label: principal.customer_name,
                    id: principal.id
                }))
                this.setState({
                    principal: {
                        ...this.state.principal,
                        data: principalList
                    },
                    showLoadingPrincipal: false,
                });
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListDistributorByMultiId = id => {
        this.setState({ showLoadingDistributor: true });
        API_REPORT.getListDistributorByMultiIdReportPrincipal(this.state.distributor.page, this.state.distributor.limit, id, this.props.token)
            .then(res => {
                let distributorList = getContent(res).map(distributor => ({
                    value: distributor.user_nexcare_id,
                    label: distributor.customer_name,
                    id: distributor.id
                }))
                if (this._isMounted) {
                    this.setState({
                        distributor: {
                            ...this.state.distributor,
                            data: distributorList
                        },
                        showLoadingDistributor: false,
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListSearchDistributorByMultiId = keyword => {
        this.setState({ showLoadingDistributor: true });
        API_REPORT.getListSearchDistributorByMultiIdReportPrincipal(this.state.distributor.page, this.state.distributor.limit, keyword, this.state.principal.id, this.state.distributorCodeArray.id, this.props.token)
            .then(res => {
                let distributorList = getContent(res).map(distributor => ({
                    value: distributor.user_nexcare_id,
                    label: distributor.customer_name,
                    id: distributor.id
                }))
                if (this._isMounted) {
                    this.setState({
                        distributor: {
                            ...this.state.distributor,
                            data: distributorList
                        },
                        showLoadingDistributor: false,
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListDistributorCodeByMultiId = () => {
        this.setState({ showLoadingDistributorCodeArray: true });
        API_REPORT.getListDistributorCodeByMultiIdReportPrincipal(this.state.distributorCodeArray.page, this.state.distributorCodeArray.limit, this.state.principal.id, this.state.distributor.id, this.props.token)
            .then(res => {
                let distributorCodeList = getContent(res).map(distributorCode => ({
                    value: distributorCode.distributor_code,
                    label: distributorCode.distributor_code,
                    id: distributorCode.distributor_code
                }))
                if (this._isMounted) {
                    this.setState({
                        distributorCodeArray: {
                            ...this.state.distributorCodeArray,
                            data: distributorCodeList
                        },
                        showLoadingDistributorCodeArray: false,
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListSearchDistributorCodeByMultiId = keyword => {
        if (!this.state.principal.id && !this.state.distributor.id) {
            return this.setState({
                distributorCodeArray: {
                    ...this.state.distributorCodeArray,
                    data: [],
                    value: [],
                    id: ''
                }
            });
        }
        this.setState({ showLoadingDistributorCodeArray: true });
        API_REPORT.getListSearchDistributorCodeByMultiIdReportPrincipal(this.state.distributorCodeArray.page, this.state.distributorCodeArray.limit, this.state.principal.id, this.state.distributor.id, keyword, this.props.token)
            .then(res => {
                let distributorCodeList = getContent(res).map(distributorCode => ({
                    value: distributorCode.distributor_code,
                    label: distributorCode.distributor_code,
                    id: distributorCode.distributor_code
                }))
                if (this._isMounted) {
                    this.setState({
                        distributorCodeArray: {
                            ...this.state.distributorCodeArray,
                            data: distributorCodeList
                        },
                        showLoadingDistributorCodeArray: false,
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListDistributorByPrincipalAndDistributorCode = id => {
        this.setState({ showLoadingDistributor: true });
        API_REPORT.getListDistributorByPrincipalAndDistributorCodeReportPrincipal(this.state.distributor.page, this.state.distributor.limit, this.state.principal.id, id, this.props.token)
            .then(res => {
                let distributorList = getContent(res).map(distributor => ({
                    value: distributor.user_nexcare_id,
                    label: distributor.customer_name,
                    id: distributor.id
                }))
                if (this._isMounted) {
                    this.setState({
                        distributor: {
                            ...this.state.distributor,
                            data: distributorList
                        },
                        showLoadingDistributor: false,
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListPriority = () => {
        API_REPORT.getListPriorityReportPrincipal(this.state.status.page, this.state.status.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        priority: {
                            ...this.state.priority,
                            data: getContent(res)
                        }
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getInitiateReport = () => {
        API_REPORT.getInitiateReportRequest(this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        report: {
                            ...this.state.report,
                            total: getContent(res).count_data
                        }
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListReport = () => {
        API_REPORT.getReportRequest(this.state.report.page, this.state.report.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        report: {
                            ...this.state.report,
                            data: getContent(res)
                        }
                    });
                    this.getInitiateReport();
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    handleChangePrincipal = data => {
        this.setState({
            principal: {
                ...this.state.principal,
                value: data,
                id: this.convertIdMultiArrayToString(data),
            },
            distributor: {
                ...this.state.distributor,
                value: [],
                id: '',
            },
            distributorCodeArray: {
                ...this.state.distributorCodeArray,
                data: [],
                value: [],
                id: '',
            }
        },
            () => {
                setTimeout(() => {
                    if (!this.state.distributorCodeArray.id) {
                        this.getListDistributorByMultiId(this.state.principal.id);
                    }
                    if (this.state.principal.id) {
                        this.getListDistributorCodeByMultiId();
                    }
                }, 100);
            }
        )
    }

    handleChangeDistributor = data => {
        this.setState({
            distributor: {
                ...this.state.distributor,
                value: data,
                id: this.convertIdMultiArrayToString(data),
            },
            distributorCodeArray: {
                ...this.state.distributorCodeArray,
                data: [],
                value: [],
                id: '',
            }
        },
            () => {
                setTimeout(() => {
                    this.getListPrincipal(this.state.distributor.id)
                    this.getListDistributorCodeByMultiId()
                }, 100);
            }
        )
    }

    handleChangeDistributorCodeArray = data => {
        this.setState({
            distributorCodeArray: {
                ...this.state.distributorCodeArray,
                value: data,
                id: this.convertIdMultiArrayToString(data),
            },
        },
            () => {
                setTimeout(() => {
                    this.getListDistributorByPrincipalAndDistributorCode(this.state.distributorCodeArray.id)
                }, 100);
            }
        )
    }

    handleChangePriority = data => {
        this.setState({
            priority: {
                ...this.state.priority,
                value: data,
            }
        })
    }


    handleChangeStatus = data => {
        this.setState({
            status: {
                ...this.state.status,
                value: data.map(data => ({ 'status_ticket': data.remark }))
            }
        })
    }

    handleChangeDistributorCode = () => {
        this.setState({
            distributorCode: !this.state.distributorCode
        })
    }

    handleLoadMore = async () => {
        await this.setState({
            report: {
                ...this.state.report,
                page: this.state.report.page + 1
            }
        })
        API_REPORT.getReportRequest(this.state.report.page, this.state.report.limit, this.props.token)
            .then(res => {
                if (getContent(res).length === 0) {
                    return this.setState({
                        showLoadMore: false
                    })
                }
                let arr = this.state.report.data.concat(getContent(res))
                this.setState({
                    report: {
                        ...this.state.report,
                        data: arr
                    }
                });
                clearInterval(this.intervalId);
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    handleConfirmExportFile = () => {
        if (this.state.principal.value.length > 1) {
            let principalName = '';
            this.state.principal.value.map((data, index) => {
                if (index === 0) {
                    return principalName = data.label
                } else {
                    return principalName = principalName + ', ' + data.label
                }
            })
            return this.setState({
                showConfirmAlertDownload: true,
                titleConfirmAlertDownload: `Apakah Anda yakin mengunduh file dengan principal ${principalName}?`
            })
        }
        this.setState({
            showConfirmAlertDownload: true,
            titleConfirmAlertDownload: 'Apakah Anda yakin mengunduh file ini?'
        })
    }

    handleConfirmSendEmail = () => {
        if (this.state.principal.value.length === 0) {
            return this.setState({ showErrorAlert: true })
        }
        if (this.state.principal.value.length > 1) {
            let principalName = '';
            this.state.principal.value.map((data, index) => {
                if (index === 0) {
                    return principalName = data.label
                } else {
                    return principalName = principalName + ', ' + data.label
                }
            })
            return this.setState({
                showConfirmAlertEmail: true,
                titleConfirmAlertEmail: `Apakah Anda yakin mengirim email dengan principal ${principalName}?`
            })
        }
        this.setState({
            showConfirmAlertEmail: true,
            titleConfirmAlertEmail: 'Apakah Anda yakin mengirim email ini?'
        })
    }

    handleReportRequest = async option => {
        if (option === 'reportemail' && this.state.principal.value === 0) {
            return this.setState({ showErrorAlert: true, showConfirmAlertEmail: false })
        }

        if (this.state.isSubmitted) {
            return console.log('Data ini sudah pernah diproses!');
        }

        this.setState({
            isSubmitted: true,
        })

        const data = {
            customer: this.state.distributor.value.map((data => ({ 'customer_id': data.value }))),
            principal_array: this.state.principal.value.map((data => data.value)),
            ticket_status: this.state.status.value,
            period_start: this.state.periodStart === '' ? '' : moment(this.state.periodStart).format('YYYY-MM-DD'),
            period_end: this.state.periodEnd === '' ? '' : moment(this.state.periodEnd).format('YYYY-MM-DD'),
            distributor_flag: this.state.distributorCode,
            report_type: "monthly",
            report_option: option,
            priority: this.state.priority.value.map((data => data.remark)),
            distributor_code: this.state.distributorCodeArray.id ? this.state.distributorCodeArray.id.split(",") : [],
        }

        API_REPORT.postReportRequest(data, this.props.token)
            .then(res => {
                this.getListReport();
                this.setState({
                    showSuccessAlert: true,
                    showConfirmAlertDownload: false,
                    showConfirmAlertEmail: false
                })
                setTimeout(() => this.setState({ showSuccessAlert: false }), 1500)
                setTimeout(() => window.location.reload(), 1500)
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    isSubmitted: false,
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true,
                    showConfirmAlertDownload: false,
                    showConfirmAlertEmail: false
                })
            }))
    }

    getDateRange = (from, to) => {
        this.setState({
            periodStart: from,
            periodEnd: to
        })
    }

    resetDateRange = () => {
        this.setState({
            periodStart: '',
            periodEnd: ''
        })
    }

    handleDateRange = e => {
        if (this.dropdownRef && !this.dropdownRef.current.contains(e.target) && this.dateRangeRef && !this.dateRangeRef.current.contains(e.target)) {
            this.setState({
                showDateRange: false
            })
        }
    }

    convertIdMultiArrayToString = value => {
        let tempArrayId = value.map(data => { return data["id"] });
        return tempArrayId.join(",");
    }

    componentDidMount() {
        this._isMounted = true;
        this.dropdownRef = createRef();
        this.dateRangeRef = createRef();

        this.getListPrincipal('');
        this.getListDistributorByMultiId('');
        this.setState({
            status: {
                ...this.state.status,
                data: MENU_REPORT.dataStatus
            }
        });
        this.getListPriority();
        this.intervalId = setInterval(() => this.getListReport(), 120000);
        this.getListReport();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.showDateRange !== this.state.showDateRange) {
            if (this.state.showDateRange) {
                document.addEventListener('click', this.handleDateRange)
            }
        }
    }

    componentWillUnmount() {
        this._isMounted = false;

        clearInterval(this.intervalId);
        document.removeEventListener('click', this.handleDateRange);
    }

    render() {
        const animatedComponents = makeAnimated();
        return (
            <CheckPermissionComponent permissionConstant={[PRINCIPAL_TICKET_REPORT_VIEW, PRINCIPAL_TICKET_REPORT_VIEW_OWN]} userPermission={this.props.userDetail.permissions}>
                <ReactTooltip
                    id="report-principal"
                    place="right"
                    type="info"
                    effect="solid"
                />
                <div className="space-y-3">
                    <BreadCrumbs
                        parentMenu="Laporan"
                        serviceMenu="Laporan Tiket Principal"
                        title="Laporan Tiket Principal"
                    />

                    {/* WHITECONTAINER */}
                    <div className="calculate-layout-breadcrumb">
                        <div className="h-full relative">
                            <div className="bg-white rounded-lg p-5 flex h-90-percent">
                                <div className="left w-1/4 h-full p-2 overflow-y-auto">
                                    <div className="mb-3">
                                        <label>Principal</label>
                                        <Select
                                            isLoading={this.state.showLoadingPrincipal}
                                            inputId="ddsprincipal"
                                            closeMenuOnSelect={false}
                                            components={animatedComponents}
                                            isMulti
                                            placeholder="Pilih Principal"
                                            options={this.state.principal.data}
                                            value={this.state.principal.value}
                                            onChange={this.handleChangePrincipal}
                                            onInputChange={this.getSearchPrincipal}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label>Distributor</label>
                                        <Select
                                            isLoading={this.state.showLoadingDistributor}
                                            inputId="mlscustomer"
                                            closeMenuOnSelect={false}
                                            components={animatedComponents}
                                            isMulti
                                            placeholder="Pilih Distributor"
                                            options={this.state.distributor.data}
                                            value={this.state.distributor.value}
                                            onChange={this.handleChangeDistributor}
                                            onInputChange={this.getListSearchDistributorByMultiId}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label>Kode Distributor</label>
                                        <Select
                                            isLoading={this.state.showLoadingDistributorCodeArray}
                                            isMulti
                                            inputId="ddsdistributorcode"
                                            closeMenuOnSelect={false}
                                            placeholder="Pilih Kode Distributor"
                                            options={this.state.distributorCodeArray.data}
                                            value={this.state.distributorCodeArray.value}
                                            onChange={this.handleChangeDistributorCodeArray}
                                            onInputChange={this.getListSearchDistributorCodeByMultiId}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label>Status</label>
                                        <Select
                                            inputId="mlsstatus"
                                            closeMenuOnSelect={false}
                                            components={animatedComponents}
                                            isMulti
                                            placeholder="Pilih Status"
                                            options={this.state.status.data}
                                            onChange={this.handleChangeStatus}
                                        />
                                    </div>
                                    <div className="mb-3 relative">
                                        <label>Periode <span className="text-darkred">*</span></label>
                                        <div className="form-control select-none" id="btnperiodreport" onClick={() => this.setState({ showDateRange: !this.state.showDateRange })} ref={this.dropdownRef} tabIndex="-1">
                                            {
                                                this.state.periodStart === '' || this.state.periodEnd === '' ?
                                                    <div className="flex justify-between items-center">
                                                        <div className="placeholder">Pilih Periode</div>
                                                        <FontAwesomeIcon icon={faChevronDown} className="select-icon" />
                                                    </div>
                                                    :
                                                    <div className="flex justify-between items-center">
                                                        <div>{moment(this.state.periodStart).format('DD/MM/YYYY')} - {moment(this.state.periodEnd).format('DD/MM/YYYY')}</div>
                                                        <FontAwesomeIcon icon={faChevronDown} className="select-icon" />
                                                    </div>
                                            }
                                        </div>
                                        <div className={this.state.showDateRange ? "bg-white absolute w-full mt-1 z-10" : "hidden"} ref={this.dateRangeRef}>
                                            <DateRange
                                                getDateRange={this.getDateRange}
                                                resetDateRange={this.resetDateRange}
                                                handleSave={() => this.setState({ showDateRange: !this.state.showDateRange })}
                                            />
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        <label>Prioritas</label>
                                        <Select
                                            isMulti
                                            inputId="ddsprioritas"
                                            closeMenuOnSelect={false}
                                            placeholder="Pilih Prioritas"
                                            value={this.state.priority.value}
                                            onChange={this.handleChangePriority}
                                            options={this.state.priority.data.map(data => ({ value: data.id, label: data.description, remark: data.remark }))}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <input type="checkbox" id="ckbdistributorcode" className="mr-3" checked={this.state.distributorCode} onChange={this.handleChangeDistributorCode} />
                                        <label htmlFor="ckbdistributorcode">Kode Distributor</label>
                                    </div>
                                    <span className="text-darkred">* keterangan wajib diisi</span>
                                </div>
                                <div className="right w-3/4 ml-5 overflow-y-auto">
                                    {
                                        this.state.report.data.map(data =>
                                            <div className="bg-lightbluegrey rounded w-full shadow text-gray-700 px-5 py-1 2xl:py-1.5 mb-3" key={data?.id}>
                                                <div className="flex justify-between items-center">
                                                    <div className="w-1/2">
                                                        <div
                                                            className="text-lg font-medium truncate"
                                                            title={
                                                                data?.customer === '' && data.principal === ''
                                                                    ? 'All Principal'
                                                                    : data?.customer === '' ? data?.principal : data?.customer
                                                            }
                                                        >
                                                            {
                                                                data?.customer === '' && data.principal === ''
                                                                    ? 'All Principal'
                                                                    : data?.customer === '' ? data?.principal : data?.customer
                                                            }
                                                        </div>
                                                        <div className="font-medium">
                                                            <span>{moment(data?.period_start).format('DD MMM YYYY')}</span>
                                                            <span className="mx-1">-</span>
                                                            <span className="mr-2">{moment(data?.period_end).format('DD MMM YYYY')} </span>
                                                        </div>
                                                    </div>
                                                    <div className="text-sm flex justify-between items-center">
                                                        <span className="mr-3">Oleh {data?.cs}</span>
                                                        <span className="mr-3">{moment.utc(data?.created_at).format('DD MMM YYYY HH:mm')}</span>
                                                        <div className="w-10 font-medium mr-3">{data?.percentage}%</div>
                                                        <div className="flex justify-center">
                                                            {
                                                                data?.report_status === "finish"
                                                                    ? data?.report_option === "reportdownload" || data?.report_option === "reportexport"
                                                                        ? <div className="mx-0.5" title="Berhasil Eksport File" data-for="report-principal"><IconReportSuccess /></div>
                                                                        : <div className="mx-0.5" title="Berhasil Kirim File" data-for="report-principal"><IconReportSendEmail /></div>
                                                                    : data?.report_status === "error"
                                                                        ? <div className="mx-0.5" title={"Gagal Kirim File " + data?.error_message} data-for="report-principal"><IconReportWarning /></div>
                                                                        : <div className="mx-0.5" title="Sedang Diproses" data-for="report-principal"><IconReportWarning /></div>
                                                            }
                                                        </div>
                                                        <a
                                                            className={data?.report_status === "finish" && (data?.report_option === "reportdownload" || data?.report_option === "reportexport") ? "ml-3" : "hidden"}
                                                            href={data?.host + data?.link_report}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            <IconReportDownload />
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }
                                    <div className={this.state.showLoadMore && this.state.report.total > this.state.report.limit ? "flex justify-center" : "hidden"}>
                                        <button type="button" id="btnmore" className="bg-white rounded text-darkblue border border-darkblue focus:outline-none px-10 py-1" onClick={() => this.handleLoadMore()}>Tampilkan Lebih Banyak</button>
                                    </div>
                                </div>
                            </div>

                            <div className="absolute right-0 bottom-0">
                                {
                                    this.props.userDetail.level === ROLE_CATEGORY_CONSTANT.PRINCIPAL
                                        ?
                                        <CheckPermissionComponent permissionConstant={[PRINCIPAL_TICKET_REPORT_EXPORT_FILE_VIEW]} userPermission={this.props.userDetail.permissions}>
                                            <button type="submit" id="btnexport" className="bg-lightblue rounded text-white px-8 py-2" onClick={() => this.handleConfirmExportFile()}>Eksport File</button>
                                        </CheckPermissionComponent>
                                        : <div className="flex items-center">
                                            <CheckPermissionComponent permissionConstant={[PRINCIPAL_TICKET_REPORT_SEND_FILE_VIEW]} userPermission={this.props.userDetail.permissions}>
                                                <button type="submit" id="btnsend" className="bg-lightblue rounded text-white px-8 py-2 mr-1" onClick={() => this.handleConfirmSendEmail()}>Kirim File</button>
                                            </CheckPermissionComponent>
                                            <CheckPermissionComponent permissionConstant={[PRINCIPAL_TICKET_REPORT_EXPORT_FILE_VIEW]} userPermission={this.props.userDetail.permissions}>
                                                <button type="submit" id="btnexport" className="bg-darkblue rounded text-white px-8 py-2 ml-1" onClick={() => this.handleConfirmExportFile()}>Eksport File</button>
                                            </CheckPermissionComponent>
                                        </div>
                                }
                            </div>

                            <Alert show={this.state.showConfirmAlertDownload} icon="warning" button={true} title={this.state.titleConfirmAlertDownload} close={() => this.setState({ showConfirmAlertDownload: false })} submit={() => this.handleReportRequest("reportdownload")} />
                            <Alert show={this.state.showConfirmAlertEmail} icon="warning" button={true} title={this.state.titleConfirmAlertEmail} close={() => this.setState({ showConfirmAlertEmail: false })} submit={() => this.handleReportRequest("reportemail")} />
                            <Alert show={this.state.showSuccessAlert} icon="success" title="Data berhasil diproses!" />
                            <Alert show={this.state.showErrorAlert} icon="warning" title="Nama principal tidak boleh kosong!" close={() => this.setState({ showErrorAlert: false })} ok />
                            <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
                        </div>
                    </div>
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(PrincipalTicket);